import moment from "moment";
import React, { useMemo, useState } from "react";
import { ITimelineColumnProps } from "src/components/Planner/TimelineColumn/TimelineColumn";
import { UnstyledButton } from "src/ui";
import { CaptionBody, SmallBody } from "src/components/Text";
import { localize } from "src/l10n";
import { dayLangTags, monthLangTags } from "../utils";
import TimelineColumnBase from "./TimelineColumnBase";
import TimelineColumnLabelCallout from "./TimelineColumnLabelCallout";

const isMiddleOfMonth = (m: any) => {
    const daysInMonth = m.daysInMonth();
    const middleDay = Math.ceil(daysInMonth / 2);
    return m.date() === middleDay;
}

const TimelineColumnWeek = (props: ITimelineColumnProps) => {
    const data = useMemo(() => {
        const m = moment(props.item.startMilliseconds);
        return {
            isThursday: m.isoWeekday() === 4,
            isSunday: m.isoWeekday() === 7,
            isFirstOfMonth: m.date() === 1,
            dateIsMiddleOfTheMonth: isMiddleOfMonth(m),
            weekDayChar: localize(dayLangTags[m.isoWeekday() - 1])[0],
            dateNumber: m.format("D"),
            momentDate: m,
            isoWeekday: m.isoWeekday(),
            isActive: m.isSame(moment(), 'day')
        }
    }, [props.item.startMilliseconds]);

    const [displayCallout, setDisplayCallout] = useState(false);
    const columnId = "column-" + props.item.startMilliseconds;

    return (
        <TimelineColumnBase
            columnIndex={props.columnIndex}
            columnWidth={props.columnWidth}
            reportHeaderHeight={props.reportHeaderHeight}
            headerHeightDeps={[props.displayLabelRow]}
            laneClassName={"weekday-" + data.isoWeekday}
            elevatedZIndex={data.dateIsMiddleOfTheMonth || data.isThursday}
            header={(
                <>
                    <div
                        className={[
                            "header-column",
                            data.isFirstOfMonth ? "border-left" : "",
                        ].filter(x => !!x).join(" ")}
                        style={{
                            height: 32,
                            width: props.columnWidth,
                        }}>
                        <SmallBody color="gray">{data.dateIsMiddleOfTheMonth && (localize(monthLangTags[data.momentDate.month()]) + " " + data.momentDate.format("YYYY"))}</SmallBody>
                    </div>
                    <div
                        className={[
                            "header-column",
                            data.isSunday ? "border-right" : "",
                        ].filter(x => !!x).join(" ")}
                        style={{
                            height: 32,
                            width: props.columnWidth,
                        }}>
                        <SmallBody>{data.isThursday && (localize("Vecka") + " " + data.momentDate.isoWeek())}</SmallBody>
                    </div>
                    {props.displayLabelRow && (
                        <UnstyledButton
                            className="header-column border-right label"
                            disabled={!props.rights.canEditLabels}
                            style={{
                                width: props.columnWidth
                            }}
                            onClick={() => {
                                setDisplayCallout(!displayCallout);
                            }}
                        >
                            <CaptionBody weight="medium">{props.label?.text}</CaptionBody>
                        </UnstyledButton>
                    )}
                    <UnstyledButton
                        id={columnId}
                        disabled={!props.rights.canEditLabels}
                        className={[
                            "header-column",
                            "border-right",
                            "date",
                            (data.isActive ? " active" : "")
                        ].join(" ")}
                        style={{
                            width: props.columnWidth,
                            height: 36,
                        }}
                        onClick={() => {
                            setDisplayCallout(!displayCallout);
                        }}
                    >
                        <div>
                            <SmallBody color="gray">{data.weekDayChar}</SmallBody>
                            <SmallBody>{data.dateNumber}</SmallBody>
                        </div>
                    </UnstyledButton>
                    <TimelineColumnLabelCallout
                        isOpen={displayCallout}
                        targetId={"#" + columnId}
                        date={new Date(props.item.startMilliseconds)}
                        onClose={() => {
                            setDisplayCallout(!displayCallout);
                        }}
                    />
                </>
            )}
        />
    )
}

export default TimelineColumnWeek;
